/** Clinical Analytics Types */

/** Overview */
export const GET_CLIENT_OVERVIEW = 'GET_CLIENT_OVERVIEW';
export const GET_CLIENT_OVERVIEW_SUCCESS = 'GET_CLIENT_OVERVIEW_SUCCESS';

/** Domain Progress */
export const GET_DOMAIN_PROGRESS = 'GET_DOMAIN_PROGRESS';
export const GET_DOMAIN_PROGRESS_SUCCESS = 'GET_DOMAIN_PROGRESS_SUCCESS';

/** Goals Progress */
export const GET_GOALS_PROGRESS = 'GET_GOALS_PROGRESS';
export const GET_GOALS_PROGRESS_SUCCESS = 'GET_GOALS_PROGRESS_SUCCESS';

/** Goal Drilldown */
export const GET_GOAL_DRILLDOWN = 'GET_GOAL_DRILLDOWN';
export const GET_GOAL_DRILLDOWN_SUCCESS = 'GET_GOAL_DRILLDOWN_SUCCESS';
export const GET_GOAL_DRILLDOWN_SUMMARY = 'GET_GOAL_DRILLDOWN_SUMMARY';
export const GET_GOAL_DRILLDOWN_SUMMARY_SUCCESS = 'GET_GOAL_DRILLDOWN_SUMMARY_SUCCESS';
export const GET_GOAL_DRILLDOWN_TARGETS = 'GET_GOAL_DRILLDOWN_TARGETS';
export const GET_GOAL_DRILLDOWN_TARGETS_SUCCESS = 'GET_GOAL_DRILLDOWN_TARGETS_SUCCESS';

/** Reset */
export const RESET_CLINICAL_ANALYTICS = 'RESET_CLINICAL_ANALYTICS';
export const RESET_GOAL_DRILLDOWN = 'RESET_GOAL_DRILLDOWN';
